import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App";
import { AuthProvider } from "./auth";
import { LocaleProvider } from "./i18n";
import { BrowserRouter } from "./router";
import { ConfirmDialogProvider } from "./components/ConfirmDialog";
import { AppRecoveryBoundary } from "./components/AppRecoveryBoundary";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry(failureCount, error) {
        if (error instanceof Error && "status" in error) {
          const status = Number((error as { status: number }).status);
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
    },
    mutations: { retry: false },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppRecoveryBoundary>
    <QueryClientProvider client={queryClient}>
      <LocaleProvider>
        <ConfirmDialogProvider>
          <BrowserRouter>
            <AuthProvider>
              <Suspense fallback={<div className="boot-screen" role="status">ກຳລັງໂຫຼດ / กำลังโหลด…</div>}>
                <App />
              </Suspense>
            </AuthProvider>
          </BrowserRouter>
        </ConfirmDialogProvider>
      </LocaleProvider>
    </QueryClientProvider>
    </AppRecoveryBoundary>
  </StrictMode>,
);
